<template>
  <select  :id="selectedId" v-model="elementSelect"
           class="form-control is-invalid retirerBordure"
  >
    <option data-placeholder="true"></option>
    <option v-for="item in data" :key="item.id" :value="returnValue === 'id' ? item.id :item.text">
      {{ item.text }}
    </option>
  </select>
</template>

<script>
import SlimSelect from "slim-select";

export default {
  name: "SlimElement",
  props:{
    afficher:Boolean,
    selectedId:String,
    element:String,
    data:Array,
    returnValue:String,
  },
  computed:{
    elementSelect:{
      get:function (){
        return this.element;
      },
      set:function (newValue){
        this.$emit('update:element',newValue+'');
      }
    }
  },

  watch:{
    elementSelect:function (val){
      if (val){
        this.slimElement.set(val);
      }
    }
  },
  data(){
    return {
      slimElement:Object
    }
  },
  methods:{

  },

  mounted() {
    let id = '#'+this.selectedId;
    let slim = new SlimSelect({
      select: id,
      placeholder: 'Select',
    });
    this.slimElement = slim;
    if (!this.afficher){
      let element = document.getElementById(this.selectedId);
      if (element){
        element.remove();
        slim.destroy();
      }
    }
  }
}
</script>

<style scoped>

</style>